// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * GET /internal-doctors/:userId/fichas (spec 20261026-142400, D4/D5): which hospital asks the internal doctor for which
 * ficha, merged with the doctor's signatures. `groupBy=true` gives one row per hospital (with `count`), `groupBy=false`
 * with `hospital=<uuid>` one row per ficha of that hospital (no `count`). A row with no signature yet is
 * `DOCTOR_FICHA_PENDING_SIGNATURE`.
 */
export const DOCTOR_FICHA_PENDING_SIGNATURE = 3

/** The signature rows come from a raw legacy query: dates as `Date` before JSON, counts as numbers or numeric strings. */
const numberOrNumericString = z.union([z.number(), z.string()])
const dateOrIsoString = z.union([z.string(), z.date()])

export const doctorFichaRowSchema = z.object({
    id: z.number().optional(),
    id_user: z.number(),
    id_hospital: z.number().nullable(),
    uuid: z.string().nullable(),
    hospital_name: z.string().nullable().optional(),
    name: z.string().nullable().optional(),
    cd_procedencia: z.number().nullable(),
    cod_pf: numberOrNumericString.nullable(),
    status: z.number().int(),
    updated_at: dateOrIsoString.nullable(),
    approved_at: dateOrIsoString.nullable(),
    page_id: z.string().nullable(),
    count: numberOrNumericString.optional(),
})
export type DoctorFichaRow = z.infer<typeof doctorFichaRowSchema>

/** Inside the `data` envelope: the page of rows and the total (hospitals when grouped, fichas when expanded). */
export const doctorFichasResponseSchema = z.tuple([
    z.array(doctorFichaRowSchema),
    z.number().int().nonnegative(),
])
export type DoctorFichasResponse = z.infer<typeof doctorFichasResponseSchema>
